<div class="container mt-4 pt-4">
    <h2 class="text-center">Advanced ROI Calculator -- Coming soon</h2>
    <!-- <form [formGroup]="roiForm" (ngSubmit)="calculateRoI()">
        <div class="row align-items-center pt-2">
            <div class="col-6">
                <div class="row align-items-center single-line-row pt-2">
                    <label class="form-label col-6 mb-0">Procedure done at practice / month</label>
                    <div class="col-4">
                    <input type="number" class="form-control" formControlName="possibleProcedurePerMonth" required />
                    </div>
                </div>
                <div class="row align-items-center single-line-row pt-2">
                    <label class="form-label col-6 mb-0">Cost Per Procedure (USD)</label>
                    <div class="col-4">

                        <input type="number" class="form-control" formControlName="costPerProcedure" required />
                    </div>
                </div>
                <div class="row align-items-center single-line-row pt-2">
                    <label class="form-label col-6 mb-0">Current Cancellation Percentage</label>
                    <div class="col-4">
                        <input type="number" class="form-control" formControlName="currentCancellationPercentage"
                        required />
                    </div>
                </div>
                <div class="row align-items-center single-line-row pt-2">
                    <label class="form-label col-6 mb-0">Expected Cancellation Percentage</label>
                    <div class="col-4">
                        <input type="number" class="form-control" formControlName="expectedCancellationPercentage"
                            required />
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="row align-items-center single-line-row pt-2">
                    <label class="form-label col-8 mb-0">Details 1</label>
                    <div class="col-4">
                    </div>
                </div>
                <div class="row align-items-center single-line-row pt-2">
                    <label class="form-label col-8 mb-0">Expected revenue per month</label>
                    <div class="col-4">
                        <label class="form-label">{{ revenuePerMonth | currency:'USD' }}</label>
                    </div>
                </div>
                <div class="row align-items-center single-line-row pt-2">
                    <label class="form-label col-8 mb-0">Details 2</label>
                    <div class="col-4">
                    </div>
                </div>
                <div class="row align-items-center single-line-row pt-2">
                    <label class="form-label col-8 mb-0">Details 3</label>
                    <div class="col-4">
                    </div>
                </div>
                <div class="row align-items-center single-line-row pt-2">
                    <label class="form-label col-8 mb-0">Details</label>
                    <div class="col-4">
                    </div>
                </div>
                <div class="row align-items-center single-line-row pt-2">
                    <label class="form-label col-8 mb-0">Details</label>
                    <div class="col-4">
                    </div>
                </div>
            </div>
        </div>
        <div class=" pt-4">
            <button type="submit" class="btn btn-primary" [disabled]="!roiForm.valid">Calculate ROI</button>
        </div>
    </form> -->

    <div *ngIf="roi !== null" class="mt-4 alert alert-info resultBox">
        <div class="row">
            <div class="col-4"></div>
            <div class="col-4">Per Month</div>
            <div class="col-4">Per Year</div>
        </div>
        <div class="row">
            <div class="col-4">Current Revenue</div>
            <div class="col-4">{{ currentPerMonthRevenue | currency:'USD' }}</div>
            <div class="col-4">{{ currentPerMonthRevenue*12 | currency:'USD' }}</div>
        </div>
        <div class="row">
            <div class="col-4">With SpeechMED+GI, Expected Revenue</div>
            <div class="col-4">{{ expectedPerMonthRevenue | currency:'USD' }}</div>
            <div class="col-4">{{ expectedPerMonthRevenue*12 | currency:'USD' }}</div>
        </div>
        <div class="row">
            <div class="col-4">With SpeechMED+GI, Improvement in Revenue</div>
            <div class="col-4">{{ increaseInRevenue | currency:'USD' }}</div>
            <div class="col-4">{{ increaseInRevenue*12 | currency:'USD' }}</div>
        </div>
        <div class="row">
            <div class="col-4">Cost of SpeechMED+GI</div>
            <div class="col-4">{{ costPerMonthForSpeechMEDGI | currency:'USD' }}</div>
            <div class="col-4">{{ costPerMonthForSpeechMEDGI*12 | currency:'USD' }}</div>
        </div>
        <div class="row">
            <div class="col-4">With SpeechMED+GI, ROI</div>
            <div class="col-8">{{ roi }}%</div>
        </div>
    </div>

    <div *ngIf="roi !== null" class="mt-4 alert alert-danger">
        <div class="row">
            <h4>absoulateCancelledProcedure : {{absoulateCancelledProcedure}}</h4>
            <h4>currentPerMonthRevenue : {{currentPerMonthRevenue}}</h4>
            <h4>expectedCancelledProcedure : {{expectedCancelledProcedure}}</h4>
            <h4>expectedPerMonthRevenue : {{expectedPerMonthRevenue}}</h4>
            <h4>increaseInRevenue : {{increaseInRevenue}}</h4>
            <h4>costPerMonthForSpeechMEDGI : {{costPerMonthForSpeechMEDGI}}</h4>
            <h4>roi : {{roi}}</h4>
        </div>
    </div>
</div>